import { type ReactElement } from "react";
import { Avatar } from "@citibox-panel/ui";
import { Row } from "./DemoScaffold";

export function AvatarDemo(): ReactElement {
  return (
    <Row>
      <Avatar>AB</Avatar>
      <Avatar src="https://i.pravatar.cc/64">CD</Avatar>
    </Row>
  );
}
